import { render, staticRenderFns } from "./MallSortTable.vue?vue&type=template&id=6409d94d&scoped=true"
import script from "./MallSortTable.vue?vue&type=script&lang=js"
export * from "./MallSortTable.vue?vue&type=script&lang=js"
import style0 from "./MallSortTable.vue?vue&type=style&index=0&id=6409d94d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6409d94d",
  null
  
)

export default component.exports